export default __webpack_public_path__ + "static/media/chiklihole_reservoir.049d9b74.jpg";